import { logger } from "../../debug";
import { getRegion } from "../../generalUtils/envFns";
import { SemiLAM2 } from "../google/types";
import { extractGlobalsFromLam } from "../google/utils";
import eventHandlers from "./ads";
import { emeaManagerConversionId, intlConversionIdsByLocale, intlConversionLabels, namConversionIdsByLocale, namConversionLabels, namManagerConversionId, namManagerConversionLabelByLocale } from "./const";

export class GoogleAdsHandlerNotFoundError extends Error {
  constructor(event: string) {
    super(`Google Ads Handler for ${event} does not exist`);
    this.name = "GoogleAdsHandlerNotFoundError";
  }
}

export function getGoogleAdsAccountId(region: string): [string | undefined, string | undefined] {
    if (region === "en-ca" || region === "fr-ca") {
        region = "canada";
    } else if (region === "us" || region === "en-us") {
        region = "default";
    } // else use the existing value

    const accountId =  namConversionIdsByLocale?.[region] ?? intlConversionIdsByLocale?.[region];
    const managerAccountId = 
        (region === "default" || region === "canada") 
        ? namManagerConversionId 
        : emeaManagerConversionId;
    return [
        accountId,
        managerAccountId,
    ]
}

export function getGoogleAdsConversionLabel(region: string, event: string) {
    if (region === "en-ca" || region === "fr-ca") {
        region = "canada";
    } else if (region === "us" || region === "en-us") {
        region = "default";
    } // else use the existing value
    const conversionLabels = (region === "default" || region === "canada")
        ? namConversionLabels
        : intlConversionLabels;

    const accConversionLabel = 
        conversionLabels?.[event]?.["account"]?.[region] ?? undefined;
    const managerAccConversionLabel =
        conversionLabels?.[event]?.["manager"]?.[region] ?? undefined;

    if (accConversionLabel === undefined) {
        logger.debug(`Google Ads Conversion Label for event ${event} in region ${region} not found, this is a required value`);
    }
        
    return {
        accConversionLabel,
        managerAccConversionLabel,
    }
}

export function googleAdsEvent(
    event: string,
    data: SemiLAM2,
    gtag: (
        type: "event",
        eventName: "conversion",
        eventParams: Record<string, any>
    ) => void,
) {
    if (event === undefined || event === null) {
        return "ERROR: Missing Event";
    }

    if (data === undefined || data === null) {
        return "ERROR: Missing data";
    }

    const handlerObject = eventHandlers[event];

    if (handlerObject === undefined) {
        throw new GoogleAdsHandlerNotFoundError(event);
    }

    const result = handlerObject.handler(handlerObject.name, data);
    gtag("event", handlerObject?.action ?? "conversion", result.data);
    // No globals outside of currency really...
}